<template>
  <form @submit.prevent="filter">
    <div class="card filters">
      <header class="card-header is-size-4">
        <div class="card-header-title has-text-dark">
          <p>FILTERS</p>
        </div>
        <div class="buttons">
          <slot name="headerButtons" />
          <b-button type="is-white" @click="reset">
            <span class="icon"><i class="fa fa-times-circle fa-lg"></i></span>
          </b-button>
        </div>
      </header>
      <div class="card-content scrollable">
        <div class="columns is-multiline is-vcentered">
          <template v-for="field in customFields">
            <component
              :is="field.component"
              :value.sync="field.value"
              v-bind="field.props"
              :key="field.id"
              :ref="field.ref"
              @input="field.onInput"
            />
          </template>
        </div>
      </div>
      <footer class="card-footer">
        <div class="columns">
          <div class="column">
            <b-button
              id="submit_order_filter"
              name="submit_order_filter"
              class="is-fullwidth"
              native-type="submit"
              type="is-info"
            >
              Filter
            </b-button>
          </div>
        </div>
      </footer>
    </div>
  </form>
</template>

<script>
import { sortBy } from "lodash";
import { orderFilterMixin } from "@/components/OrderFilter/mixins/orderFilterMixin";

export default {
  mixins: [orderFilterMixin],
  computed: {
    userFields() {
      const user = this.$store.state.Auth.user;

      if (user && user.attributes) {
        const attribute = user.attributes.find(
          field => field.code === "[SYSTEM][ORDERS]"
        );

        if (attribute) return JSON.parse(attribute.value);
      }

      return [];
    },
    customFields() {
      let order = this.defaultFields.length + 1;
      let fields = this.defaultFields.reduce((acc, field) => {
        const userField = this.userFields.find(
          userField => userField.id === field.id
        );

        if (userField) {
          if (!userField.visible) return acc;
          field.order = userField.order;
        } else {
          field.order = order;
          order++;
        }

        // Force column size to is-12
        // if (field.props) field.props.columnSize = "is-12";

        acc.push(field);

        return acc;
      }, []);

      return sortBy(fields, ["order"]);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/OrderFilter/OrderFilterExperimental.vue